var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 106,
    viewBox: "0 0 108 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#E5E8FA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 3c0 1.657-16.118 3-36 3S0 4.657 0 3s16.118-3 36-3 36 1.343 36 3",
    transform: "translate(-587 -187) translate(416 139) translate(171 48) translate(18 99) matrix(1 0 0 -1 0 6)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#272C4D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M50.5 102L50.5 69 56.5 69 56.5 102",
    transform: "translate(-587 -187) translate(416 139) translate(171 48)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#272C4D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M19.682 0L0 19.682 0 47.518 19.682 67.2 47.518 67.2 67.2 47.518 67.2 19.682 47.518 0z",
    transform: "translate(-587 -187) translate(416 139) translate(171 48) translate(20 2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFFA",
    d: "M54.399 16.215L61 22.816v22.368L45.184 61H22.816l-6.601-6.601 38.184-38.184zM45.184 7l5.237 5.238-38.184 38.184L7 45.184V22.816L22.816 7h22.368z",
    transform: "translate(-587 -187) translate(416 139) translate(171 48) translate(20 2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStop);
export default __webpack_public_path__ + "static/media/img-stop.d7b3f9dd69696524384af6cdb2614b6e.svg";
export { ForwardRef as ReactComponent };